export const Card = ({ data }) => {
  return (
    <div className="cod-card">
      <div>
        <div className="vector-image">
          <img src={data.icon} alt={data.headline} />
        </div>
        <h4>{data.headline}</h4>
        <div className="cod-details">
          {data.details.map((d, i) => (
            <div key={i} className="specific-detail">
              <img
                src="assets/images/kwikcheckoutcod/tick.svg"
                alt="Tick Mark"
              />
              <span>{d}</span>
            </div>
          ))}
        </div>
      </div>
      <div>
        <button>
          <strong>Impact:</strong>
          <span>{data.cta}</span>
        </button>
      </div>
    </div>
  );
};
